<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>
    <breadcrumb class="breadcrumb-container"/>
    <div class="right-menu">
      <b><el-button type="info" plain size="mini" @click="logout">{{ empInfo.groupName + '-' + empInfo.stationName + '-' + empInfo.empName }}</el-button></b>
      <!--<error-log class="errLog-container right-menu-item"/>-->
      <el-tooltip :content="$t('navbar.screenfull')" effect="dark" placement="bottom">
        <screenfull class="screenfull right-menu-item"/>
      </el-tooltip>

      <!--<el-dropdown class="avatar-container right-menu-item" trigger="click">-->
      <!--&lt;!&ndash;        <div class="avatar-wrapper">-->
      <!--<img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->
      <!--<i class="el-icon-caret-bottom"/>-->
      <!--</div>-->
      <!--<el-dropdown-menu slot="dropdown">-->
      <!--<router-link to="/">-->
      <!--<el-dropdown-item>-->
      <!--{{ $t('navbar.dashboard') }}-->
      <!--</el-dropdown-item>-->
      <!--</router-link>-->
      <!--<el-dropdown-item divided>-->
      <!--<span style="display:block;" @click="logout">{{ $t('navbar.logOut') }}</span>-->
      <!--</el-dropdown-item>-->
      <!--</el-dropdown-menu>&ndash;&gt;-->
      <!--</el-dropdown>-->
    </div>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import LangSelect from '@/components/LangSelect'
import SizeSelect from '@/components/SizeSelect'
import ThemePicker from '@/components/ThemePicker'
import { getEmpInfo } from '../../../utils/auth'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    LangSelect,
    SizeSelect,
    ThemePicker
  },
  data () {
    return {
      empInfo: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar'
    ])
  },
  created () {
    this.getEmpName()
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    },
    getEmpName () {
      if (getEmpInfo()) {
        this.empInfo = getEmpInfo()
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }
    .international {
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
